"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// usePreferencesState.ts
var react_1 = require("react");
var preferencesStore_1 = require("../storage/preferencesStore");
var bootstrap_1 = require("../bootstrap");
var api_1 = require("../api");
function usePreferencesState(userId) {
    if (userId === void 0) { userId = 0; }
    var preferences = (0, react_1.useSyncExternalStore)(preferencesStore_1.subscribePreferences, preferencesStore_1.getPreferences);
    var resolvedUserId = (0, react_1.useMemo)(function () { return (userId === 0 ? (0, bootstrap_1.userIdFromDOM)() : userId); }, [userId]);
    var isEnabled = (0, react_1.useCallback)(function (kind, channel) {
        var pref = preferences.find(function (p) { return p.user_id === resolvedUserId && p.kind === kind && p.channel === channel; });
        // default-on for database channel; push is opt-in (default off)
        return pref ? pref.enabled : channel === 'database';
    }, [preferences, resolvedUserId]);
    var setEnabled = (0, react_1.useCallback)(function (kind, channel, enabled) {
        void (0, api_1.setPreferenceEnabled)({
            userId: resolvedUserId,
            kind: kind,
            channel: channel,
            enabled: enabled,
        });
    }, [resolvedUserId]);
    var enabledCount = (0, react_1.useMemo)(function () {
        return function (channel, kinds) {
            return kinds.reduce(function (acc, kind) { return acc + (isEnabled(kind, channel) ? 1 : 0); }, 0);
        };
    }, [isEnabled]);
    return { preferences: preferences, isEnabled: isEnabled, setEnabled: setEnabled, enabledCount: enabledCount };
}
exports.default = usePreferencesState;
